//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';





















































































































//-----Types.File-----
export interface AbpLoginResult {
    result: LoginResultType;
    readonly description: string | null;
}

export interface AccountProviderDto {
    readonly extraProperties: { [key: string]: any; };
    name: string;
    providerIdentifier: string | null;
    accountIdentifier: string | null;
    authenticationMethod: AuthenticationMethod;
    displayName: string | null;
    groupId: string | null;
    groupName: string | null;
    imageUri: string | null;
    market: string | null;
    fields: Field[];
}

export interface AccountProviderIdentifierDto {
    name: string;
    providerIdentifier: string | null;
    market: string | null;
}

export interface ActionApiDescriptionModel {
    uniqueName: string;
    name: string;
    httpMethod: string | null;
    url: string;
    supportedVersions: string[] | null;
    parametersOnMethod: MethodParameterApiDescriptionModel[];
    parameters: ParameterApiDescriptionModel[];
    returnValue: ReturnValueApiDescriptionModel;
    allowAnonymous: boolean | null;
    authorizeDatas: AuthorizeDataApiDescriptionModel[];
    implementFrom: string | null;
    summary: string | null;
    remarks: string | null;
    description: string | null;
    displayName: string | null;
}

export interface AdminAssetDto {
    id: string;
    type: AssetType;
    isListed: boolean;
    isAccount: boolean;
    isHoldings: boolean;
    name: string;
    currency: string;
    symbol: string | null;
    normalizedTicker: string | null;
    isin: string | null;
    figi: string | null;
    market: string | null;
    identifier: string | null;
    interestRate: number | null;
    currentPrice: number | null;
    previousPrice: number | null;
    totalValue: number | null;
    imageUri: string | null;
    updated: string;
    historicalPrices: HistoricalPrices | null;
    dataSource: DataSource;
}

export interface AmountDto {
    value: number;
    currency: string;
}

export interface ApplicationApiDescriptionModel {
    modules: { [key: string]: ModuleApiDescriptionModel; };
    types: { [key: string]: TypeApiDescriptionModel; };
}

export interface ApplicationAuthConfigurationDto {
    grantedPolicies: { [key: string]: boolean; };
}

export interface ApplicationConfigurationDto {
    localization: ApplicationLocalizationConfigurationDto;
    auth: ApplicationAuthConfigurationDto;
    setting: ApplicationSettingConfigurationDto;
    currentUser: CurrentUserDto;
    features: ApplicationFeatureConfigurationDto;
    globalFeatures: ApplicationGlobalFeatureConfigurationDto;
    multiTenancy: MultiTenancyInfoDto;
    currentTenant: CurrentTenantDto;
    timing: TimingDto;
    clock: ClockDto;
    objectExtensions: ObjectExtensionsDto;
    extraProperties: { [key: string]: any; };
}

export interface ApplicationFeatureConfigurationDto {
    values: { [key: string]: string; };
}

export interface ApplicationGlobalFeatureConfigurationDto {
    enabledFeatures: string[];
}

export interface ApplicationLocalizationConfigurationDto {
    values: { [key: string]: { [key: string]: string; }; };
    resources: { [key: string]: ApplicationLocalizationResourceDto; };
    languages: LanguageInfo[];
    currentCulture: CurrentCultureDto;
    defaultResourceName: string | null;
    languagesMap: { [key: string]: NameValue[]; };
    languageFilesMap: { [key: string]: NameValue[]; };
    useRouteBasedCulture: boolean;
}

export interface ApplicationLocalizationDto {
    resources: { [key: string]: ApplicationLocalizationResourceDto; };
    currentCulture: CurrentCultureDto;
}

export interface ApplicationLocalizationResourceDto {
    texts: { [key: string]: string; };
    baseResources: string[];
}

export interface ApplicationSettingConfigurationDto {
    values: { [key: string]: string; };
}

export enum AssetCollection {
    All = 0,
    Listed = 1,
    Unlisted = 2,
    Cash = 3,
    Holdings = 4,
    Loans = 5,
}

export interface AssetDto {
    id: string;
    type: AssetType;
    isListed: boolean;
    isAccount: boolean;
    isHoldings: boolean;
    name: string;
    currency: string;
    symbol: string | null;
    normalizedTicker: string | null;
    isin: string | null;
    figi: string | null;
    market: string | null;
    identifier: string | null;
    interestRate: number | null;
    currentPrice: number | null;
    previousPrice: number | null;
    totalValue: number | null;
    imageUri: string | null;
    updated: string;
    historicalPrices: HistoricalPrices2 | null;
}

export interface AssetEventDto {
    type: EventType;
    subType: EventSubType | null;
    date: string;
    value: number | null;
    currency: string | null;
    imageUri: string | null;
    assetId: string;
    assetName: string;
}

export interface AssetListDataDto {
    items: CalculatedValueResultDto[];
}

export enum AssetListType {
    Winners = 1,
    Losers = 2,
    Both = 3,
}

export interface AssetSearchInput {
    searchTerm: string;
    assetTypes: AssetType[];
    maxResultCount: number;
}

export interface AssetTimeSeriesEntryDto {
    timestamp: number;
    value: number;
}

export enum AssetType {
    Stock = 0,
    Fund = 1,
    Cash = 2,
    SavingsAccount = 3,
    CryptoCurrency = 4,
    Other = 5,
    Loan = 6,
    Index = 7,
    Commodity = 8,
}

export enum AuthenticationMethod {
    BankID = 0,
    Redirect = 1,
}

export interface AuthorizeDataApiDescriptionModel {
    policy: string | null;
    roles: string | null;
}

export enum BankIdStatus {
    Pending = 0,
    Failed = 1,
    Complete = 2,
}

export interface BarChartSettingsDto {
    combineBars: boolean;
}

export interface BucketDto {
    portfolioId: string;
    startDate: string;
    endDate: string;
    currency: string;
    netDeposits: number | null;
    initialValue: PortfolioTimeSeriesEntryDto | null;
    entries: PortfolioTimeSeriesEntryDto[];
    transactions: TransactionDto[];
}

export interface CalculatedValueDto {
    displayName: string | null;
    valueType: ValueType;
    valueSource: ValueSource | null;
    params: ValueParamsDto | null;
    nestedValues: CalculatedValueDto[] | null;
}

export interface CalculatedValueResultDto {
    readonly extraProperties: { [key: string]: any; };
    displayName: string;
    value: number;
    valueSource: ValueSource;
    valueType: ValueType;
    currency: CurrencyDto | null;
    isStale: boolean;
}

export interface CalendarDataDto {
    events: DashboardEventDto[];
}

export interface ChangePasswordInput {
    currentPassword: string | null;
    newPassword: string;
}

export interface ClockDto {
    kind: string;
}

export interface ConfirmEmailInput {
    userId: string;
    confirmationToken: string;
}

export enum ContributionType {
    WEEKLY_START = 0,
    WEEKLY_END = 1,
    MONTHLY_START = 2,
    MONTHLY_END = 3,
    QUARTERLY_START = 4,
    QUARTERLY_END = 5,
    YEARLY_START = 6,
    YEARLY_END = 7,
}

export interface ControllerApiDescriptionModel {
    controllerName: string;
    controllerGroupName: string | null;
    isRemoteService: boolean;
    isIntegrationService: boolean;
    apiVersion: string | null;
    type: string;
    summary: string | null;
    remarks: string | null;
    description: string | null;
    displayName: string | null;
    interfaces: ControllerInterfaceApiDescriptionModel[];
    actions: { [key: string]: ActionApiDescriptionModel; };
}

export interface ControllerInterfaceApiDescriptionModel {
    type: string;
    name: string;
    methods: InterfaceMethodApiDescriptionModel[];
}

export interface CurrencyDto {
    code: string;
    displayName: string;
}

export interface CurrentCultureDto {
    displayName: string;
    englishName: string;
    threeLetterIsoLanguageName: string;
    twoLetterIsoLanguageName: string;
    isRightToLeft: boolean;
    cultureName: string;
    name: string;
    nativeName: string;
    dateTimeFormat: DateTimeFormatDto;
}

export interface CurrentTenantDto {
    id: string | null;
    name: string | null;
    isAvailable: boolean;
}

export interface CurrentUserDto {
    isAuthenticated: boolean;
    id: string | null;
    tenantId: string | null;
    impersonatorUserId: string | null;
    impersonatorTenantId: string | null;
    impersonatorUserName: string | null;
    impersonatorTenantName: string | null;
    userName: string | null;
    name: string | null;
    surName: string | null;
    email: string | null;
    emailVerified: boolean;
    phoneNumber: string | null;
    phoneNumberVerified: boolean;
    roles: string[];
    sessionId: string | null;
}

export interface DashboardEventDto {
    type: EventType;
    subType: EventSubType;
    date: string;
    value: AmountDto | null;
    imageUri: string | null;
    relatedEntities: LookupDtoOfGuid[];
}

export interface DashboardItemCreateDto {
    type: DashboardItemType;
    settings: DashboardItemSettingsDto | null;
}

export interface DashboardItemDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    type: DashboardItemType;
    order: number;
    settings: DashboardItemSettingsDto;
}

export interface DashboardItemSettingsDto {
    title: string | null;
    layout: number;
    listType: AssetListType | null;
    period: DateConstant | null;
    portfolios: string[] | null;
    sections: string[] | null;
    assetTypes: AssetType[] | null;
    values: CalculatedValueDto[] | null;
    savingsGoal: string | null;
    pieChartSettings: PieChartSettingsDto | null;
    barChartSettings: BarChartSettingsDto | null;
    portfolioComparisonSettings: PortfolioComparisonSettingsDto | null;
}

export enum DashboardItemType {
    Date = 1,
    PortfolioOverview = 2,
    PortfolioHistory = 3,
    SavingsGoal = 4,
    AssetList = 5,
    EventView = 6,
    NetSavings = 7,
}

export enum DataSource {
    YahooFinance = 0,
    Nordnet = 1,
    Morningstar = 2,
    CoinGecko = 3,
}

export enum DateConstant {
    OneDay = 0,
    OneWeek = 1,
    OneMonth = 2,
    ThreeMonths = 3,
    SixMonths = 4,
    ThisYear = 5,
    OneYear = 6,
    ThreeYears = 7,
    FiveYears = 8,
    Max = 9,
}

export interface DateTimeFormatDto {
    calendarAlgorithmType: string;
    dateTimeFormatLong: string;
    shortDatePattern: string;
    fullDateTimePattern: string;
    dateSeparator: string;
    shortTimePattern: string;
    longTimePattern: string;
}

export enum DuplicateAssetStrategy {
    Combine = 0,
    None = 1,
}

export interface EmailSettingsDto {
    smtpHost: string | null;
    smtpPort: number;
    smtpUserName: string | null;
    smtpPassword: string | null;
    smtpDomain: string | null;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
    defaultFromAddress: string | null;
    defaultFromDisplayName: string | null;
}

export interface EntityExtensionDto {
    properties: { [key: string]: ExtensionPropertyDto; };
    configuration: { [key: string]: any; };
}

export enum EventSubType {
    PaymentDate = 1,
    XDay = 2,
    InterimReportQ1 = 10,
    InterimReportQ2 = 11,
    InterimReportQ3 = 12,
    InterimReportQ4 = 13,
    ExtraordinaryGeneralMeeting = 20,
}

export enum EventType {
    Dividend = 0,
    Earnings = 1,
    GeneralMeeting = 2,
    Split = 3,
    RightsIssue = 4,
    ShareRedemption = 5,
    Other = 100,
}

export interface ExchangeRateDto {
    readonly id: string;
    baseCurrency: string;
    toCurrency: string;
    rate: number;
}

export interface ExtensionEnumDto {
    fields: ExtensionEnumFieldDto[];
    localizationResource: string | null;
}

export interface ExtensionEnumFieldDto {
    name: string | null;
    value: any | null;
}

export interface ExtensionPropertyApiCreateDto {
    isAvailable: boolean;
}

export interface ExtensionPropertyApiDto {
    onGet: ExtensionPropertyApiGetDto;
    onCreate: ExtensionPropertyApiCreateDto;
    onUpdate: ExtensionPropertyApiUpdateDto;
}

export interface ExtensionPropertyApiGetDto {
    isAvailable: boolean;
}

export interface ExtensionPropertyApiUpdateDto {
    isAvailable: boolean;
}

export interface ExtensionPropertyAttributeDto {
    typeSimple: string;
    config: { [key: string]: any; };
}

export interface ExtensionPropertyDto {
    type: string;
    typeSimple: string;
    displayName: LocalizableStringDto | null;
    api: ExtensionPropertyApiDto;
    ui: ExtensionPropertyUiDto;
    policy: ExtensionPropertyPolicyDto;
    attributes: ExtensionPropertyAttributeDto[];
    configuration: { [key: string]: any; };
    defaultValue: any | null;
}

export interface ExtensionPropertyFeaturePolicyDto {
    features: string[];
    requiresAll: boolean;
}

export interface ExtensionPropertyGlobalFeaturePolicyDto {
    features: string[];
    requiresAll: boolean;
}

export interface ExtensionPropertyPermissionPolicyDto {
    permissionNames: string[];
    requiresAll: boolean;
}

export interface ExtensionPropertyPolicyDto {
    globalFeatures: ExtensionPropertyGlobalFeaturePolicyDto;
    features: ExtensionPropertyFeaturePolicyDto;
    permissions: ExtensionPropertyPermissionPolicyDto;
}

export interface ExtensionPropertyUiDto {
    onTable: ExtensionPropertyUiTableDto;
    onCreateForm: ExtensionPropertyUiFormDto;
    onEditForm: ExtensionPropertyUiFormDto;
    lookup: ExtensionPropertyUiLookupDto;
}

export interface ExtensionPropertyUiFormDto {
    isVisible: boolean;
}

export interface ExtensionPropertyUiLookupDto {
    url: string;
    resultListPropertyName: string;
    displayPropertyName: string;
    valuePropertyName: string;
    filterParamName: string;
}

export interface ExtensionPropertyUiTableDto {
    isVisible: boolean;
}

export interface ExternalAccountAuthenticateCollectDto {
    provider: AccountProviderIdentifierDto;
    code: string | null;
}

export interface ExternalAccountDto {
    displayName: string;
    userIdentifier: string | null;
    updated: string | null;
    syncTransactions: boolean;
    provider: AccountProviderDto;
}

export enum ExternalAccountType {
    ISK = 0,
    KF = 1,
    Depot = 2,
    Pension = 3,
    SavingsAccount = 4,
    Checking = 5,
    Credit = 6,
    Mortgage = 7,
    Other = 8,
}

export interface ExternalAccountUpdateDto {
    syncTransactions: boolean;
}

export interface ExternalAssetSearchDto {
    name: string | null;
    dataSource: DataSource;
    assetType: AssetType;
    identifier: string;
    symbol: string | null;
    isin: string | null;
    normalizedTicker: string | null;
    market: string | null;
    imageUri: string | null;
}

export interface ExternalDataSourceDto {
    dataSource: DataSource;
    isEnabled: boolean;
    priority: number;
}

export interface ExternalDataSourceSetEnabledInput {
    isEnabled: boolean;
}

export interface ExternalDataSourceSetPriorityInput {
    priority: number;
}

export interface ExternalPortfolioDto {
    id: string;
    portfolioType: ExternalAccountType;
    accountId: string;
    accountNumber: string | null;
    accountType: string | null;
    accountSubType: string | null;
    name: string;
    cashValue: number | null;
    interestRate: number | null;
    currency: string;
    provider: AccountProviderDto;
    instruments: InstrumentDto[];
}

export interface FeatureDto {
    name: string | null;
    displayName: string | null;
    value: string | null;
    provider: FeatureProviderDto | null;
    description: string | null;
    valueType: IStringValueType | null;
    depth: number;
    parentName: string | null;
}

export interface FeatureGroupDto {
    name: string | null;
    displayName: string | null;
    features: FeatureDto[] | null;
}

export interface FeatureProviderDto {
    name: string | null;
    key: string | null;
}

export interface Field {
    defaultValue: string | null;
    description: string | null;
    visible: boolean;
    group: string | null;
    helpText: string | null;
    placeholder: string | null;
    readonly: boolean;
    masked: boolean | null;
    maxLength: number | null;
    minLength: number | null;
    name: string;
    numeric: boolean;
    oneOf: boolean;
    required: boolean;
    options: string[];
    pattern: string | null;
    patternError: string | null;
    type: string | null;
    value: string | null;
    additionalInfo: any | null;
    selectOptions: SelectOption[];
}

export interface FindTenantResultDto {
    success: boolean;
    tenantId: string | null;
    name: string | null;
    normalizedName: string | null;
    isActive: boolean;
}

export interface GetFeatureListResultDto {
    groups: FeatureGroupDto[] | null;
}

export interface GetPermissionListResultDto {
    entityDisplayName: string | null;
    groups: PermissionGroupDto[] | null;
}

export interface GetResourcePermissionDefinitionListResultDto {
    permissions: ResourcePermissionDefinitionDto[] | null;
}

export interface GetResourcePermissionListResultDto {
    permissions: ResourcePermissionGrantInfoDto[] | null;
}

export interface GetResourcePermissionWithProviderListResultDto {
    permissions: ResourcePermissionWithProdiverGrantInfoDto[] | null;
}

export interface GetResourceProviderListResultDto {
    providers: ResourceProviderDto[] | null;
}

export interface GrantedResourcePermissionDto {
    name: string | null;
    displayName: string | null;
}

export interface IDashboardData {
}

export interface IStringValueType {
    readonly name: string;
    readonly properties: { [key: string]: any; };
    validator: IValueValidator;
}

export interface IValueValidator {
    readonly name: string;
    readonly properties: { [key: string]: any; };
}

export interface IanaTimeZone {
    timeZoneName: string | null;
}

export interface IdentityLockoutSettingsDto {
    allowedForNewUsers: boolean;
    duration: number;
    maxFailedAccessAttempts: number;
}

export interface IdentityPasswordSettingsDto {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireNonAlphanumeric: boolean;
    requiredLength: number;
    requiredUniqueChars: number;
}

export interface IdentityRoleCreateDto {
    readonly extraProperties: { [key: string]: any; };
    name: string;
    isDefault: boolean;
    isPublic: boolean;
}

export interface IdentityRoleDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    name: string | null;
    isDefault: boolean;
    isStatic: boolean;
    isPublic: boolean;
    concurrencyStamp: string | null;
    creationTime: string;
}

export interface IdentityRoleUpdateDto {
    readonly extraProperties: { [key: string]: any; };
    name: string;
    isDefault: boolean;
    isPublic: boolean;
    concurrencyStamp: string | null;
}

export interface IdentitySettingsDto {
    signIn: IdentitySignInSettingsDto;
    user: IdentityUserSettingsDto;
    lockout: IdentityLockoutSettingsDto;
    password: IdentityPasswordSettingsDto;
}

export interface IdentitySignInSettingsDto {
    requireConfirmedEmail: boolean;
    enablePhoneNumberConfirmation: boolean;
    requireConfirmedPhoneNumber: boolean;
}

export interface IdentityUserCreateDto {
    readonly extraProperties: { [key: string]: any; };
    userName: string;
    name: string | null;
    surname: string | null;
    email: string;
    phoneNumber: string | null;
    isActive: boolean;
    lockoutEnabled: boolean;
    roleNames: string[] | null;
    password: string;
}

export interface IdentityUserDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    creationTime: string;
    creatorId: string | null;
    lastModificationTime: string | null;
    lastModifierId: string | null;
    isDeleted: boolean;
    deleterId: string | null;
    deletionTime: string | null;
    tenantId: string | null;
    userName: string | null;
    name: string | null;
    surname: string | null;
    email: string | null;
    emailConfirmed: boolean;
    phoneNumber: string | null;
    phoneNumberConfirmed: boolean;
    isActive: boolean;
    lockoutEnabled: boolean;
    accessFailedCount: number;
    lockoutEnd: string | null;
    concurrencyStamp: string | null;
    entityVersion: number;
    lastPasswordChangeTime: string | null;
}

export interface IdentityUserSettingsDto {
    isUserNameUpdateEnabled: boolean;
    isEmailUpdateEnabled: boolean;
}

export interface IdentityUserUpdateDto {
    readonly extraProperties: { [key: string]: any; };
    userName: string;
    name: string | null;
    surname: string | null;
    email: string;
    phoneNumber: string | null;
    isActive: boolean;
    lockoutEnabled: boolean;
    roleNames: string[] | null;
    password: string | null;
    concurrencyStamp: string | null;
}

export interface IdentityUserUpdateRolesDto {
    roleNames: string[];
}

export interface ImportSettings {
    sectionId: string;
    isHidden: boolean;
    isManualAsset: boolean;
    hasSelectedListedAsset: boolean;
    duplicateAssetStrategy: DuplicateAssetStrategy;
}

export interface InstrumentDto {
    id: string;
    portfolioId: string;
    assetType: AssetType;
    name: string;
    quantity: number | null;
    totalValue: number | null;
    profit: number | null;
    averageAcquisitionPrice: number | null;
    averageAcquisitionPriceAssetCurrency: number | null;
    interestRate: number | null;
    currency: string;
    isin: string | null;
    marketPlace: string | null;
    currentPrice: number | null;
    symbol: string | null;
    imageUri: string | null;
    searchResult: ExternalAssetSearchDto[];
    importSettings: ImportSettings;
}

export interface InterfaceMethodApiDescriptionModel {
    name: string;
    parametersOnMethod: MethodParameterApiDescriptionModel[];
    returnValue: ReturnValueApiDescriptionModel;
}

export enum KeyFinancialRatio {
    StandardDeviation = 0,
    SharpeRatio = 1,
    CAGR = 2,
}

export interface KeyFinancialRatios {
    stdDev: number;
    sharpeRatio: number;
    cagr: number;
}

export interface LanguageInfo {
    cultureName: string;
    uiCultureName: string;
    displayName: string;
    readonly twoLetterISOLanguageName: string;
}

export interface ListResultDtoOfAccountProviderDto {
    items: AccountProviderDto[];
}

export interface ListResultDtoOfAssetEventDto {
    items: AssetEventDto[];
}

export interface ListResultDtoOfAssetTimeSeriesEntryDto {
    items: AssetTimeSeriesEntryDto[];
}

export interface ListResultDtoOfBucketDto {
    items: BucketDto[];
}

export interface ListResultDtoOfDashboardItemDto {
    items: DashboardItemDto[];
}

export interface ListResultDtoOfExchangeRateDto {
    items: ExchangeRateDto[];
}

export interface ListResultDtoOfExternalAccountDto {
    items: ExternalAccountDto[];
}

export interface ListResultDtoOfExternalAssetSearchDto {
    items: ExternalAssetSearchDto[];
}

export interface ListResultDtoOfExternalDataSourceDto {
    items: ExternalDataSourceDto[];
}

export interface ListResultDtoOfExternalPortfolioDto {
    items: ExternalPortfolioDto[];
}

export interface ListResultDtoOfIdentityRoleDto {
    items: IdentityRoleDto[];
}

export interface ListResultDtoOfLookupDtoOfGuid {
    items: LookupDtoOfGuid[];
}

export interface ListResultDtoOfSectionLookupDto {
    items: SectionLookupDto[];
}

export interface ListResultDtoOfSyncedAssetDto {
    items: SyncedAssetDto[];
}

export interface ListResultDtoOfUserData {
    items: UserData[];
}

export interface LocalizableStringDto {
    name: string;
    resource: string | null;
}

export enum LoginResultType {
    Success = 1,
    InvalidUserNameOrPassword = 2,
    NotAllowed = 3,
    LockedOut = 4,
    RequiresTwoFactor = 5,
}

export interface LookupDtoOfGuid {
    id: string;
    displayName: string;
}

export interface MethodParameterApiDescriptionModel {
    name: string;
    typeAsString: string;
    type: string;
    typeSimple: string;
    isOptional: boolean;
    defaultValue: any | null;
    summary: string | null;
    description: string | null;
    displayName: string | null;
}

export interface ModuleApiDescriptionModel {
    rootPath: string;
    remoteServiceName: string;
    controllers: { [key: string]: ControllerApiDescriptionModel; };
}

export interface ModuleExtensionDto {
    entities: { [key: string]: EntityExtensionDto; };
    configuration: { [key: string]: any; };
}

export interface MoveAssetDto {
    fromSection: string;
    toSection: string;
    assetId: string;
    index: number | null;
}

export interface MultiTenancyInfoDto {
    isEnabled: boolean;
    userSharingStrategy: TenantUserSharingStrategy;
}

export interface NameValue {
    name: string;
    value: string;
}

export interface NetSavingsDataDto {
    start: string;
    end: string;
    currency: string | null;
    deposits: number;
    withdrawals: number;
    netSavings: number;
    values: { [key: string]: NetSavingsEntryDto; };
}

export interface NetSavingsEntryDto {
    date: string;
    deposits: number;
    withdrawals: number;
    netSavings: number;
}

export enum NetSavingsType {
    Total = 1,
    PerMonth = 2,
    PerYear = 3,
}

export interface NotificationDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    creationTime: string;
    creatorId: string | null;
    title: string;
    message: string | null;
    status: ReadStatus;
    severity: Severity;
    relatedEntities: RelatedEntityDto[];
}

export interface ObjectExtensionsDto {
    modules: { [key: string]: ModuleExtensionDto; };
    enums: { [key: string]: ExtensionEnumDto; };
}

export interface PagedResultDtoOfAdminAssetDto {
    items: AdminAssetDto[];
    totalCount: number;
}

export interface PagedResultDtoOfIdentityRoleDto {
    items: IdentityRoleDto[];
    totalCount: number;
}

export interface PagedResultDtoOfIdentityUserDto {
    items: IdentityUserDto[];
    totalCount: number;
}

export interface PagedResultDtoOfNotificationDto {
    items: NotificationDto[];
    totalCount: number;
}

export interface PagedResultDtoOfSharedPortfolioDto {
    items: SharedPortfolioDto[];
    totalCount: number;
}

export interface PagedResultDtoOfTenantDto {
    items: TenantDto[];
    totalCount: number;
}

export interface PagedResultDtoOfTransactionDto {
    items: TransactionDto[];
    totalCount: number;
}

export interface ParameterApiDescriptionModel {
    nameOnMethod: string;
    name: string;
    jsonName: string | null;
    type: string | null;
    typeSimple: string | null;
    isOptional: boolean;
    defaultValue: any | null;
    constraintTypes: string[] | null;
    bindingSourceId: string | null;
    descriptorName: string | null;
    summary: string | null;
    description: string | null;
    displayName: string | null;
}

export interface PermissionGrantInfoDto {
    name: string | null;
    displayName: string | null;
    parentName: string | null;
    isGranted: boolean;
    allowedProviders: string[] | null;
    grantedProviders: ProviderInfoDto[] | null;
    isEditable: boolean;
}

export interface PermissionGroupDto {
    name: string | null;
    displayName: string | null;
    displayNameKey: string | null;
    displayNameResource: string | null;
    permissions: PermissionGrantInfoDto[] | null;
}

export interface PieChartSettingsDto {
    chartType: PieChartType;
}

export enum PieChartType {
    CashHoldings = 1,
    Categories = 2,
    Assets = 3,
}

export interface PortfolioComparisonSettingsDto {
    index: ExternalAssetSearchDto | null;
    sharedPortfolioId: string | null;
}

export interface PortfolioCreateDto {
    name: string;
    currency: string;
    categoryName: string | null;
}

export interface PortfolioDto {
    id: string;
    creationTime: string;
    creatorId: string | null;
    type: string;
    name: string;
    currency: string;
    isReadonly: boolean;
    nav: number;
    shares: number;
    calculatedValue: number;
    valueChange: number | null;
    percentageChange: number | null;
    totalChange: number | null;
    totalChangePercent: number | null;
    sections: SectionDto[];
    syncedPortfolios: SyncedPortfolioDto[];
    keyFinancialRatios: KeyFinancialRatios;
    settings: PortfolioSettingsDto;
}

export interface PortfolioImportInput {
    portfolioId: string;
    providerName: string;
    accountIdentifier: string | null;
    externalPortfolios: ExternalPortfolioDto[];
}

export interface PortfolioSettingsDto {
    tableColumns: string[];
    comparisonSettings: PortfolioComparisonSettingsDto | null;
}

export interface PortfolioSortingDto {
    sections: SectionSortingDto[];
}

export interface PortfolioTimeSeriesEntryDto {
    timestamp: number;
    value: number;
    shares: number;
}

export interface PortfolioUpdateDto {
    name: string;
    tableColumns: string[] | null;
    portfolioComparisonSettings: PortfolioComparisonSettingsDto | null;
}

export interface ProfileDto {
    readonly extraProperties: { [key: string]: any; };
    userName: string | null;
    email: string | null;
    name: string | null;
    surname: string | null;
    phoneNumber: string | null;
    isExternal: boolean;
    hasPassword: boolean;
    concurrencyStamp: string | null;
}

export interface PropertyApiDescriptionModel {
    name: string;
    jsonName: string | null;
    type: string;
    typeSimple: string;
    isRequired: boolean;
    minLength: number | null;
    maxLength: number | null;
    minimum: string | null;
    maximum: string | null;
    regex: string | null;
    isNullable: boolean;
    summary: string | null;
    description: string | null;
    displayName: string | null;
}

export interface ProviderAuthenticateCollectDto {
    status: BankIdStatus;
    qrCode: string | null;
}

export interface ProviderAuthenticateDto {
    autoStartToken: string | null;
    qrCode: string | null;
    redirectUri: string | null;
}

export interface ProviderAuthenticateInput {
    providerIdentifier: string | null;
    userIdentifier: string | null;
    autostartToken: boolean;
    redirectUri: string | null;
}

export interface ProviderInfoDto {
    providerName: string | null;
    providerKey: string | null;
}

export enum ReadStatus {
    Unread = 0,
    Read = 1,
}

export interface RegisterDto {
    readonly extraProperties: { [key: string]: any; };
    userName: string;
    emailAddress: string;
    password: string;
    appName: string;
}

export interface RelatedEntityDto {
    id: string;
    displayName: string;
    entityName: string;
}

export interface RemoteServiceErrorInfo {
    code: string | null;
    message: string | null;
    details: string | null;
    data: { [key: string]: any; } | null;
    validationErrors: RemoteServiceValidationErrorInfo[] | null;
}

export interface RemoteServiceErrorResponse {
    error: RemoteServiceErrorInfo;
}

export interface RemoteServiceValidationErrorInfo {
    message: string;
    members: string[];
}

export interface ResetPasswordDto {
    userId: string;
    resetToken: string;
    password: string;
}

export interface ResourcePermissionDefinitionDto {
    name: string | null;
    displayName: string | null;
}

export interface ResourcePermissionGrantInfoDto {
    providerName: string | null;
    providerKey: string | null;
    providerDisplayName: string | null;
    providerNameDisplayName: string | null;
    permissions: GrantedResourcePermissionDto[] | null;
}

export interface ResourcePermissionWithProdiverGrantInfoDto {
    name: string | null;
    displayName: string | null;
    providers: string[] | null;
    isGranted: boolean;
}

export interface ResourceProviderDto {
    name: string | null;
    displayName: string | null;
}

export interface ReturnValueApiDescriptionModel {
    type: string;
    typeSimple: string;
    summary: string | null;
    contentTypes: string[] | null;
    isRemoteStream: boolean;
}

export interface SavingsGoalCalculationDto {
    goal: SavingsGoalTimeSeriesEntryDto[];
    progress: SavingsGoalTimeSeriesEntryDto[];
    expected: SavingsGoalTimeSeriesEntryDto[];
    annualReturns: number;
    totalReturns: number;
    netSavingsTotal: number;
    netSavingsMonthly: number;
}

export interface SavingsGoalCreateOrUpdateDto {
    name: string;
    startDate: string;
    endDate: string;
    currency: string | null;
    goalValue: number;
    contribution: number | null;
    contributionType: ContributionType | null;
    annualReturns: number | null;
    portfolios: string[];
}

export enum SavingsGoalDataPoint {
    StartDate = 0,
    CurrentValue = 1,
    EndDate = 2,
    GoalValueReached = 3,
}

export interface SavingsGoalDto {
    id: string;
    creationTime: string;
    creatorId: string | null;
    lastModificationTime: string | null;
    lastModifierId: string | null;
    isDeleted: boolean;
    deleterId: string | null;
    deletionTime: string | null;
    name: string;
    startDate: string;
    endDate: string;
    currency: CurrencyDto;
    goalValue: number;
    initialValue: number;
    contribution: number;
    contributionType: ContributionType;
    annualReturns: number;
    portfolios: string[];
}

export interface SavingsGoalPreviewDto {
    savingsGoal: SavingsGoalDto;
    goal: SavingsGoalTimeSeriesEntryDto[];
    progress: SavingsGoalTimeSeriesEntryDto[];
}

export interface SavingsGoalTimeSeriesEntryDto {
    timestamp: number;
    value: number;
    type: SavingsGoalDataPoint | null;
    hideBullet: boolean;
}

export interface SearchProviderKeyInfo {
    providerKey: string | null;
    providerDisplayName: string | null;
}

export interface SearchProviderKeyListResultDto {
    keys: SearchProviderKeyInfo[] | null;
}

export interface SectionAssetCreateDto {
    name: string;
    type: AssetType;
    currency: string | null;
    quantity: number | null;
    currentPrice: number | null;
    averageAcquisitionPrice: number | null;
    averageAcquisitionPriceAssetCurrency: number | null;
    totalValue: number | null;
    assetSearchResult: ExternalAssetSearchDto | null;
}

export interface SectionAssetDto {
    id: string;
    type: AssetType;
    isListed: boolean;
    isAccount: boolean;
    isHoldings: boolean;
    name: string;
    currency: string;
    symbol: string | null;
    normalizedTicker: string | null;
    isin: string | null;
    figi: string | null;
    market: string | null;
    identifier: string | null;
    interestRate: number | null;
    currentPrice: number | null;
    previousPrice: number | null;
    totalValue: number | null;
    updated: string;
    historicalPrices: HistoricalPrices3 | null;
    sectionId: string;
    quantity: number | null;
    averageAcquisitionPrice: AmountDto | null;
    averageAcquisitionPriceAssetCurrency: AmountDto | null;
    calculatedValue: number;
    valueChange: number | null;
    percentageChange: number | null;
    totalChange: number | null;
    totalChangePercent: number | null;
    calculatedAverageAcquisitionPrice: AmountDto | null;
    calculatedAverageAcquisitionPriceAssetCurrency: AmountDto | null;
    calculatedAcquisitionValue: AmountDto | null;
    calculatedAcquisitionValueAssetCurrency: AmountDto | null;
    isSynced: boolean;
    syncedQuantity: number | null;
    imageUri: string | null;
    assetImageUri: string | null;
    syncedAssets: SyncedAssetDto[];
}

export interface SectionAssetUpdateDto {
    name: string | null;
    imageUri: string | null;
    quantity: number | null;
    totalValue: number | null;
    averageAcquisitionPrice: number | null;
    averageAcquisitionPriceAssetCurrency: number | null;
    currentPrice: number | null;
    previousPrice: number | null;
}

export interface SectionCreateDto {
    name: string;
}

export interface SectionDto {
    id: string;
    portfolioId: string;
    name: string;
    calculatedValue: number;
    valueChange: number | null;
    totalChange: number | null;
    percentageChange: number | null;
    totalChangePercent: number | null;
    sorting: SortSetting;
    assets: SectionAssetDto[];
}

export interface SectionLookupDto {
    id: string;
    displayName: string;
    portfolioId: string;
}

export interface SectionSortingDto {
    sectionId: string;
    sorting: SortSetting;
    assets: string[] | null;
}

export interface SectionUpdateDto {
    name: string;
}

export interface SelectOption {
    id: string;
    displayName: string;
    imageUrl: string;
}

export interface SendPasswordResetCodeDto {
    email: string;
    appName: string;
    returnUrl: string | null;
    returnUrlHash: string | null;
}

export interface SendTestEmailInput {
    senderEmailAddress: string;
    targetEmailAddress: string;
    subject: string;
    body: string | null;
}

export enum Severity {
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
}

export interface SharedPortfolioDto {
    id: string;
    creatorId: string;
    portfolioName: string;
    readonly userName: string;
    readonly userProfilePictureUri: string | null;
    userCount: number;
    settings: SharedPortfolioSettings;
}

export interface SharedPortfolioSettings {
    includeHistory: boolean;
    includeNominalValues: boolean;
}

export enum SortOrder {
    Ascending = 0,
    Descending = 1,
}

export interface SortSetting {
    order: number;
    property: string | null;
    sortOrder: SortOrder;
}

export interface SyncProviderInput {
    accountIdentifier: string | null;
    providerIdentifier: string | null;
    displayName: string | null;
    username: string | null;
    syncAll: boolean | null;
    portfolioId: string | null;
    useTestProviders: boolean | null;
}

export interface SyncedAssetDto {
    id: string;
    externalAccountId: string;
    externalAccountDisplayName: string;
    portfolioId: string;
    name: string;
    quantity: number | null;
    totalValue: number | null;
    averageAcquisitionPrice: AmountDto | null;
    averageAcquisitionPriceAssetCurrency: AmountDto | null;
    interestRate: number | null;
    currency: string;
    isin: string | null;
    marketPlace: string | null;
    imageUri: string | null;
    importSettings: ImportSettings;
}

export interface SyncedPortfolioDto {
    id: string;
    externalAccountId: string;
    externalAccountDisplayName: string;
    externalAccountImageUri: string | null;
    portfolioType: ExternalAccountType;
    name: string;
    currency: string;
    accountNumber: string | null;
    interestRate: number | null;
}

export interface TenantCreateDto {
    readonly extraProperties: { [key: string]: any; };
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
}

export interface TenantDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    name: string | null;
    concurrencyStamp: string | null;
}

export interface TenantUpdateDto {
    readonly extraProperties: { [key: string]: any; };
    name: string;
    concurrencyStamp: string | null;
}

export enum TenantUserSharingStrategy {
    Isolated = 0,
    Shared = 1,
}

export interface TimeZone {
    iana: IanaTimeZone;
    windows: WindowsTimeZone;
}

export interface TimingDto {
    timeZone: TimeZone;
}

export interface TransactionCreateDto {
    portfolioId: string;
    type: TransactionType;
    date: string;
    amount: number;
    comment: string | null;
}

export interface TransactionDto {
    readonly extraProperties: { [key: string]: any; };
    id: string;
    portfolioId: string;
    type: TransactionType;
    status: TransactionStatus;
    date: string;
    amount: AmountDto;
    comment: string | null;
}

export enum TransactionStatus {
    Pending = 0,
    Completed = 1,
    PendingApproval = 2,
}

export enum TransactionType {
    Deposit = 0,
    Withdrawal = 1,
}

export interface TypeApiDescriptionModel {
    baseType: string | null;
    isEnum: boolean;
    enumNames: string[] | null;
    enumValues: any[] | null;
    genericArguments: string[] | null;
    properties: PropertyApiDescriptionModel[] | null;
    summary: string | null;
    remarks: string | null;
    description: string | null;
    displayName: string | null;
}

export interface UpdateEmailSettingsDto {
    smtpHost: string | null;
    smtpPort: number;
    smtpUserName: string | null;
    smtpPassword: string | null;
    smtpDomain: string | null;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
    defaultFromAddress: string;
    defaultFromDisplayName: string;
}

export interface UpdateFeatureDto {
    name: string | null;
    value: string | null;
}

export interface UpdateFeaturesDto {
    features: UpdateFeatureDto[] | null;
}

export interface UpdateIdentityLockoutSettingsDto {
    allowedForNewUsers: boolean;
    duration: number;
    maxFailedAccessAttempts: number;
}

export interface UpdateIdentityPasswordSettingsDto {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireNonAlphanumeric: boolean;
    requiredLength: number;
    requiredUniqueChars: number;
}

export interface UpdateIdentitySettingsDto {
    signIn: UpdateIdentitySignInSettingsDto;
    user: UpdateIdentityUserSettingsDto;
    lockout: UpdateIdentityLockoutSettingsDto;
    password: UpdateIdentityPasswordSettingsDto;
}

export interface UpdateIdentitySignInSettingsDto {
    requireConfirmedEmail: boolean;
    enablePhoneNumberConfirmation: boolean;
    requireConfirmedPhoneNumber: boolean;
}

export interface UpdateIdentityUserSettingsDto {
    isUserNameUpdateEnabled: boolean;
    isEmailUpdateEnabled: boolean;
}

export interface UpdatePermissionDto {
    name: string | null;
    isGranted: boolean;
}

export interface UpdatePermissionsDto {
    permissions: UpdatePermissionDto[] | null;
}

export interface UpdateProfileDto {
    readonly extraProperties: { [key: string]: any; };
    userName: string | null;
    email: string | null;
    name: string | null;
    surname: string | null;
    phoneNumber: string | null;
    concurrencyStamp: string | null;
}

export interface UpdateProfileSettingsDto {
    settings: { [key: string]: string; };
}

export interface UpdateResourcePermissionsDto {
    providerName: string | null;
    providerKey: string | null;
    permissions: string[] | null;
}

export interface UserData {
    id: string;
    tenantId: string | null;
    userName: string | null;
    name: string | null;
    surname: string | null;
    isActive: boolean;
    email: string | null;
    emailConfirmed: boolean;
    phoneNumber: string | null;
    phoneNumberConfirmed: boolean;
    readonly extraProperties: { [key: string]: any; } | null;
}

export interface UserLoginInfo {
    userNameOrEmailAddress: string;
    password: string;
    rememberMe: boolean;
}

export interface ValueParamsDto {
    period: DateConstant | null;
    fromCurrency: CurrencyDto | null;
    toCurrency: CurrencyDto | null;
    netSavingsType: NetSavingsType | null;
    keyFinancialRatio: KeyFinancialRatio | null;
    portfolios: string[] | null;
    sharedPortfolios: string[] | null;
    sections: string[] | null;
    assets: string[] | null;
    assetTypes: AssetType[] | null;
    assetCollection: AssetCollection | null;
    assetSearch: ExternalAssetSearchDto | null;
}

export enum ValueSource {
    Portfolio = 1,
    Asset = 2,
    ExchangeRate = 3,
    SharedPortfolio = 4,
}

export enum ValueType {
    TotalValue = 1,
    NominalChange = 2,
    PercentageChange = 4,
    NetSavings = 8,
    KeyFinancialRatio = 16,
    RelativeValue = 32,
    All = 63,
}

export interface VerifyPasswordResetTokenInput {
    userId: string;
    resetToken: string;
}

export interface WatchlistCreateDto {
    name: string;
    categoryName: string | null;
}

export interface WatchlistDto {
    id: string;
    creationTime: string;
    creatorId: string | null;
    type: string;
    name: string;
    isReadonly: boolean;
    sections: SectionDto[];
    settings: PortfolioSettingsDto;
}

export interface WatchlistUpdateDto {
    name: string;
    tableColumns: string[] | null;
    portfolioComparisonSettings: PortfolioComparisonSettingsDto | null;
}

export interface WindowsTimeZone {
    timeZoneId: string | null;
}

export interface HistoricalPrices {
    OneDay: number;
    OneWeek: number;
    OneMonth: number;
    ThreeMonths: number;
    SixMonths: number;
    ThisYear: number;
    OneYear: number;
    ThreeYears: number;
    FiveYears: number;
    Max: number;
}

export interface HistoricalPrices2 {
    OneDay: number;
    OneWeek: number;
    OneMonth: number;
    ThreeMonths: number;
    SixMonths: number;
    ThisYear: number;
    OneYear: number;
    ThreeYears: number;
    FiveYears: number;
    Max: number;
}

export interface HistoricalPrices3 {
    OneDay: number;
    OneWeek: number;
    OneMonth: number;
    ThreeMonths: number;
    SixMonths: number;
    ThisYear: number;
    OneYear: number;
    ThreeYears: number;
    FiveYears: number;
    Max: number;
}
//-----/CustomTypes.File-----

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//-----/Types.File-----

import { addResultTypeFactory } from './axios-client/helpers';
export { setBaseUrl, getBaseUrl } from './axios-client/helpers';
export { setAxiosFactory, getAxios } from './axios-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './axios-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('AbpApiDefinitionClient___abpApiDefinitionGet', (data: any) => { const result = new ApplicationApiDescriptionModel(); result.init(data); return result; });


  addResultTypeFactory('AbpApplicationConfigurationClient___abpApplicationConfigurationGet', (data: any) => { const result = new ApplicationConfigurationDto(); result.init(data); return result; });


  addResultTypeFactory('AbpApplicationLocalizationClient___abpApplicationLocalizationGet', (data: any) => { const result = new ApplicationLocalizationDto(); result.init(data); return result; });


  addResultTypeFactory('AbpTenantClient___abpTenantFindTenantByName', (data: any) => { const result = new FindTenantResultDto(); result.init(data); return result; });
  addResultTypeFactory('AbpTenantClient___abpTenantFindTenantById', (data: any) => { const result = new FindTenantResultDto(); result.init(data); return result; });






  addResultTypeFactory('AssetsClient___assetsGetList', (data: any) => { const result = new PagedResultDtoOfAdminAssetDto(); result.init(data); return result; });
  addResultTypeFactory('AssetsClient___assetsGet', (data: any) => { const result = new AssetDto(); result.init(data); return result; });
  addResultTypeFactory('AssetsClient___assetsGetEvents', (data: any) => { const result = new ListResultDtoOfAssetEventDto(); result.init(data); return result; });
  addResultTypeFactory('AssetsClient___assetsSearchV2', (data: any) => { const result = new ListResultDtoOfExternalAssetSearchDto(); result.init(data); return result; });
  addResultTypeFactory('AssetsClient___assetsGetChart', (data: any) => { const result = new ListResultDtoOfAssetTimeSeriesEntryDto(); result.init(data); return result; });
  addResultTypeFactory('AssetsClient___assetsGetChartById', (data: any) => { const result = new ListResultDtoOfAssetTimeSeriesEntryDto(); result.init(data); return result; });


  addResultTypeFactory('DashboardClient___dashboardGet', (data: any) => { const result = new ListResultDtoOfDashboardItemDto(); result.init(data); return result; });
  addResultTypeFactory('DashboardClient___dashboardGetItemData', (data: any) => { const result = new IDashboardData(); result.init(data); return result; });
  addResultTypeFactory('DashboardClient___dashboardGetCalendarData', (data: any) => { const result = new CalendarDataDto(); result.init(data); return result; });
  addResultTypeFactory('DashboardClient___dashboardGetAssetListData', (data: any) => { const result = new AssetListDataDto(); result.init(data); return result; });
  addResultTypeFactory('DashboardClient___dashboardGetNetSavingsData', (data: any) => { const result = new NetSavingsDataDto(); result.init(data); return result; });
  addResultTypeFactory('DashboardClient___dashboardGetEventViewData', (data: any) => { const result = new CalculatedValueResultDto(); result.init(data); return result; });




  addResultTypeFactory('EmailSettingsClient___emailSettingsGet', (data: any) => { const result = new EmailSettingsDto(); result.init(data); return result; });


  addResultTypeFactory('ExchangeRatesClient___exchangeRatesGetExchangeRates', (data: any) => { const result = new ListResultDtoOfExchangeRateDto(); result.init(data); return result; });


  addResultTypeFactory('ExternalAccountsClient___externalAccountsGetProviders', (data: any) => { const result = new ListResultDtoOfAccountProviderDto(); result.init(data); return result; });
  addResultTypeFactory('ExternalAccountsClient___externalAccountsGetAccounts', (data: any) => { const result = new ListResultDtoOfExternalAccountDto(); result.init(data); return result; });
  addResultTypeFactory('ExternalAccountsClient___externalAccountsGetAccount', (data: any) => { const result = new ExternalAccountDto(); result.init(data); return result; });
  addResultTypeFactory('ExternalAccountsClient___externalAccountsGetPortfolios', (data: any) => { const result = new ListResultDtoOfExternalPortfolioDto(); result.init(data); return result; });


  addResultTypeFactory('ExternalDataSourcesClient___externalDataSourcesGetList', (data: any) => { const result = new ListResultDtoOfExternalDataSourceDto(); result.init(data); return result; });


  addResultTypeFactory('FeaturesClient___featuresGet', (data: any) => { const result = new GetFeatureListResultDto(); result.init(data); return result; });


  addResultTypeFactory('IdentitySettingsClient___identitySettingsGet', (data: any) => { const result = new IdentitySettingsDto(); result.init(data); return result; });




  addResultTypeFactory('NotificationsClient___notificationsGetList', (data: any) => { const result = new PagedResultDtoOfNotificationDto(); result.init(data); return result; });


  addResultTypeFactory('PermissionsClient___permissionsGet', (data: any) => { const result = new GetPermissionListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsGetByGroup', (data: any) => { const result = new GetPermissionListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsGetResourceProviderKeyLookupServices', (data: any) => { const result = new GetResourceProviderListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsSearchResourceProviderKey', (data: any) => { const result = new SearchProviderKeyListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsGetResourceDefinitions', (data: any) => { const result = new GetResourcePermissionDefinitionListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsGetResource', (data: any) => { const result = new GetResourcePermissionListResultDto(); result.init(data); return result; });
  addResultTypeFactory('PermissionsClient___permissionsGetResourceByProvider', (data: any) => { const result = new GetResourcePermissionWithProviderListResultDto(); result.init(data); return result; });


  addResultTypeFactory('PortfoliosClient___portfoliosGetList', (data: any) => { const result = new ListResultDtoOfLookupDtoOfGuid(); result.init(data); return result; });
  addResultTypeFactory('PortfoliosClient___portfoliosGet', (data: any) => { const result = new PortfolioDto(); result.init(data); return result; });
  addResultTypeFactory('PortfoliosClient___portfoliosGetTimeSeries', (data: any) => { const result = new ListResultDtoOfBucketDto(); result.init(data); return result; });
  addResultTypeFactory('PortfoliosClient___portfoliosGetSyncSettings', (data: any) => { const result = new ListResultDtoOfSyncedAssetDto(); result.init(data); return result; });
  addResultTypeFactory('PortfoliosClient___portfoliosGetSectionLookup', (data: any) => { const result = new ListResultDtoOfSectionLookupDto(); result.init(data); return result; });


  addResultTypeFactory('ProfileClient___profileGet', (data: any) => { const result = new ProfileDto(); result.init(data); return result; });


  addResultTypeFactory('RoleClient___roleGetAllList', (data: any) => { const result = new ListResultDtoOfIdentityRoleDto(); result.init(data); return result; });
  addResultTypeFactory('RoleClient___roleGetList', (data: any) => { const result = new PagedResultDtoOfIdentityRoleDto(); result.init(data); return result; });
  addResultTypeFactory('RoleClient___roleGet', (data: any) => { const result = new IdentityRoleDto(); result.init(data); return result; });


  addResultTypeFactory('SavingsGoalsClient___savingsGoalsGetList', (data: any) => { const result = new ListResultDtoOfLookupDtoOfGuid(); result.init(data); return result; });
  addResultTypeFactory('SavingsGoalsClient___savingsGoalsGet', (data: any) => { const result = new SavingsGoalDto(); result.init(data); return result; });
  addResultTypeFactory('SavingsGoalsClient___savingsGoalsGetSavingsGoalPreview', (data: any) => { const result = new SavingsGoalPreviewDto(); result.init(data); return result; });
  addResultTypeFactory('SavingsGoalsClient___savingsGoalsGetSavingsGoalProgress', (data: any) => { const result = new SavingsGoalCalculationDto(); result.init(data); return result; });


  addResultTypeFactory('SharedPortfoliosClient___sharedPortfoliosGetList', (data: any) => { const result = new PagedResultDtoOfSharedPortfolioDto(); result.init(data); return result; });
  addResultTypeFactory('SharedPortfoliosClient___sharedPortfoliosGetSharedPortfolio', (data: any) => { const result = new PortfolioDto(); result.init(data); return result; });
  addResultTypeFactory('SharedPortfoliosClient___sharedPortfoliosGetSharedPortfolioSettings', (data: any) => { const result = new SharedPortfolioDto(); result.init(data); return result; });
  addResultTypeFactory('SharedPortfoliosClient___sharedPortfoliosGetTimeSeries', (data: any) => { const result = new ListResultDtoOfBucketDto(); result.init(data); return result; });


  addResultTypeFactory('TenantClient___tenantGet', (data: any) => { const result = new TenantDto(); result.init(data); return result; });
  addResultTypeFactory('TenantClient___tenantGetList', (data: any) => { const result = new PagedResultDtoOfTenantDto(); result.init(data); return result; });


  addResultTypeFactory('TimeZoneSettingsClient___timeZoneSettingsGetTimezones', (data: any) => { const result = new NameValue(); result.init(data); return result; });


  addResultTypeFactory('TransactionsClient___transactionsGetList', (data: any) => { const result = new PagedResultDtoOfTransactionDto(); result.init(data); return result; });
  addResultTypeFactory('TransactionsClient___transactionsGet', (data: any) => { const result = new TransactionDto(); result.init(data); return result; });


  addResultTypeFactory('UserClient___userGet', (data: any) => { const result = new IdentityUserDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userGetList', (data: any) => { const result = new PagedResultDtoOfIdentityUserDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userFindById', (data: any) => { const result = new IdentityUserDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userGetRoles', (data: any) => { const result = new ListResultDtoOfIdentityRoleDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userGetAssignableRoles', (data: any) => { const result = new ListResultDtoOfIdentityRoleDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userFindByUsername', (data: any) => { const result = new IdentityUserDto(); result.init(data); return result; });
  addResultTypeFactory('UserClient___userFindByEmail', (data: any) => { const result = new IdentityUserDto(); result.init(data); return result; });


  addResultTypeFactory('UserLookupClient___userLookupFindById', (data: any) => { const result = new UserData(); result.init(data); return result; });
  addResultTypeFactory('UserLookupClient___userLookupFindByUserName', (data: any) => { const result = new UserData(); result.init(data); return result; });
  addResultTypeFactory('UserLookupClient___userLookupSearch', (data: any) => { const result = new ListResultDtoOfUserData(); result.init(data); return result; });


  addResultTypeFactory('WatchlistsClient___watchlistsGetList', (data: any) => { const result = new ListResultDtoOfLookupDtoOfGuid(); result.init(data); return result; });
  addResultTypeFactory('WatchlistsClient___watchlistsGet', (data: any) => { const result = new WatchlistDto(); result.init(data); return result; });
  addResultTypeFactory('WatchlistsClient___watchlistsGetSectionLookup', (data: any) => { const result = new ListResultDtoOfSectionLookupDto(); result.init(data); return result; });


}
//-----/PersistorHydrator.File----